import { message } from "antd";
import { useEffect, useState } from "react";
import Progress from "react-progress-2";
import { GetDataAuth } from "../apiService/GetData";
import { apis } from "../properties";
import { useRefreshTable } from "../store";

function useTripsList(filterData) {
  const [state, setState] = useState([]);
  const refreshTable = useRefreshTable((state) => state.refreshTable);

  useEffect(() => {
    const getData = () => {
      Progress.show();
      GetDataAuth(`${apis.TRIPS_LIST}${filterData}`).then((result) => {
        let responseJson = [];
        responseJson = result;
        if (responseJson.length > 0) {
          setState(responseJson);
          Progress.hide();
        } else if (responseJson.status === "error") {
          message.error(responseJson.message);
          Progress.hide();
        } else {
          Progress.hide();
        }
      });
    };
    getData();
    // eslint-disable-next-line
  }, [filterData,refreshTable]);
  return state;
}

export default useTripsList;
